const CartSelectors = {
  form: "form",
  lineItems: ".items tbody",
  orderOverview: ".overview table",

  numberInputs: "input[type=number]",
  updateButton: "button[name=update]",
  price: "[data-price]",
  compareAtPrice: "[data-compare-at-price]",

  giftOnPurchaseItem: ".gift-on-purchase-item",
  giftOnPurchaseItemHeadline: "h3",
  giftOnPurchaseMobileActionsContainer: "td[colspan]",
  
  giftCardItem: ".gift-card-item",
  giftCardItemHeadline: "h3",
  giftCardActions: ".actions",
  giftCardMobileActionsContainer: "td[colspan]",
  giftCardActionsContainer: "td.details",
};

Shopify.theme.sections.register('cart', {
  onLoad() {
    this.section = this.container.parentNode;
    this.form = this.section.querySelector(CartSelectors.form);
    this.lineItems = this.section.querySelector(CartSelectors.lineItems);
    this.orderOverview = this.section.querySelector(CartSelectors.orderOverview);

    this._initUpdateButton();
    this._initNumberInputs();
    this._initGiftOnPurchaseItem();
    this._initGiftCardItem();
  },

  onUnload() {
  },

  _initUpdateButton() {
    this.updateButton = this.section.querySelector(CartSelectors.updateButton);
  },

  _reloadCart() {
    window.location.reload();
  },

  _updateCart() {
    if (this.updateButton) {
      this.updateButton.click();
    }
  },

  _updateQuantity(numberInput) {
    this._updateCart();
  },

  _updateQuantityInPlace(numberInput) {
    let wrapper = numberInput.closest(".quantity");
    let lineIndex = numberInput.closest("[data-line-index").dataset.lineIndex;
    let quantity = numberInput.value;
    let row = numberInput.closest("tr");
    let price = row.querySelector(CartSelectors.price);
    let compareAtPrice = row.querySelector(CartSelectors.compareAtPrice);
    let url = this.form.dataset.changeUrl + ".js";

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        line: lineIndex,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then((json) => {
      let lineItem = json.items[lineIndex - 1];
      let newQuantity = lineItem.quantity;

      if (newQuantity < quantity) {
        wrapper.classList.add("insufficient");
      } else {
        wrapper.classList.remove("insufficient");
      }

      price.innerText = formatMoney(lineItem.final_line_price);
      if (compareAtPrice) {
        compareAtPrice.innerText = formatMoney(lineItem.original_line_price);
      }
    })
    .catch((error) => {
      console.error("Cart Error", error)
    })
  },

  _initNumberInputs() {
    this.numberInputs = this.section.querySelectorAll(CartSelectors.numberInputs);

    this.numberInputs.forEach((numberInput) => {
      numberInput.addEventListener('change', (ev) => {
        this._updateQuantity(numberInput);
      })
    });
  },

  _initGiftOnPurchaseItem() {
    this.giftOnPurchaseItem = this.section.querySelector(CartSelectors.giftOnPurchaseItem);

    if (!this.giftOnPurchaseItem) {
      return
    }

    this._initGiftOnPurchaseItemHeadline();
    
    const isValid = this.giftOnPurchaseItem.dataset.isValid;
    const isInCart = this.giftOnPurchaseItem.dataset.isInCart;

    if (!this.giftOnPurchaseItem) {
      return
    }

    if (isValid && !isInCart) {
      this._addGift();
    }

    if (!isValid && isInCart) {
      this._removeGift();
    }
  },

  _initGiftOnPurchaseItemHeadline() {
    this.giftOnPurchaseItemHeadline = this.giftOnPurchaseItem.querySelector(CartSelectors.giftOnPurchaseItemHeadline);
    this.giftOnPurchaseItemHeadline.addEventListener('click', this._toggleGiftOnPurchaseItem.bind(this));
  },

  _toggleGiftOnPurchaseItem() {
    this.giftOnPurchaseItem.classList.toggle("visible");
  },

  _addGift() {
    const url = window.routes.cartAddUrl + ".js";
    const variantId = this.giftOnPurchaseItem.dataset.variantId;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        properties: {
          "Gift": "Yes"
        }
      })
    })
    .then(response => response.json())
    .then((json) => {
      this._getCart();
    })
    .catch((error) => {
      console.error("Could not add gift to cart", error)
    })
  },

  _removeGift() {
    const url = window.routes.cartChangeUrl + ".js";
    const itemKey = this.giftOnPurchaseItem.dataset.itemKey;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then((json) => {
      this._getCart();
    })
    .catch((error) => {
      console.error("Could not add remove from cart", error)
    })
  },

  _getCart() {
    // this._reloadCart();
    const url = window.routes.cartUrl;

    fetch(url, {
      method: "GET",
    })
    .then(response => response.text())
    .then((result) => {
      const doc = document.createRange().createContextualFragment(result);

      const lineItems = doc.querySelector(CartSelectors.lineItems);
      const orderOverview = doc.querySelector(CartSelectors.orderOverview);
      const cartItemCount = doc.querySelector(CartSelectors.cartItemCount).dataset.count;

      this.lineItems.replaceWith(lineItems);
      this.orderOverview.replaceWith(orderOverview);
      
      window.updateCartItemCounts(cartItemCount);

      this._initGiftCardItem();
      this._initGiftOnPurchaseItem();
      this._initNumberInputs();
      window.enhanceNumberFields();
      window.enhanceSelects();
    });
  },

  _initGiftCardItem() {
    this.giftCardItem = this.section.querySelector(CartSelectors.giftCardItem);

    if (!this.giftCardItem) {
      return
    }
    
    this._initGiftCardItemHeadline();
    this.giftCardActions = this.giftCardItem.querySelector(CartSelectors.giftCardActions);

    mqListener.on('mobile', () => {
      this.giftCardItem.querySelector(CartSelectors.giftCardMobileActionsContainer).append(this.giftCardActions);
    })
    mqListener.on('tablet', () => {
      this.giftCardItem.querySelector(CartSelectors.giftCardActionsContainer).append(this.giftCardActions);
    })
    mqListener.on('desktop', () => {
      this.giftCardItem.querySelector(CartSelectors.giftCardActionsContainer).append(this.giftCardActions);
    })
  },

  _initGiftCardItemHeadline() {
    this.giftCardItemHeadline = this.giftCardItem.querySelector(CartSelectors.giftCardItemHeadline);
    this.giftCardItemHeadline.addEventListener('click', this._toggleGiftCardItem.bind(this));
  },

  _toggleGiftCardItem() {
    this.giftCardItem.classList.toggle("visible");
  }
})
